const announcementBar = document.querySelector('.header__announcement');
const dissmissBtn = document.querySelector('.header__announcement .btn-close');
if (announcementBar && dissmissBtn) {
    dissmissBtn.addEventListener('click', () => {
      const url = '/wp/wp-admin/admin-ajax.php?action=dissmiss_announcement';
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.send(true);
      announcementBar.style.display = 'none';
    });
}